import {
  FormHelperText,
  Typography,
  FormControl,
  Input as _Input,
  InputProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { get } from "lodash";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

const StyledInput = styled(_Input)`
  background-color: white;
  padding: 0.4rem 0.7rem;
`;

type IFormInputProps = {
  name: string;
  label: string;
} & InputProps;

export const Input: FC<IFormInputProps> = ({ name, label, ...otherProps }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({ field }) => (
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Typography
            variant="body2"
          >
            {label}
          </Typography>
          <StyledInput
            {...field}
            fullWidth
            error={!!errors[name]}
            {...otherProps}
          />
          <FormHelperText error={!!errors[name]}>
          {get(errors, name) ? (get(errors, `${name}.message`) as unknown as string) : ""}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
};